<template>
    <div>

        <PageHeader>
            {{ $t('webhookTipbox') }}
        </PageHeader>

        <Card :loading="loading" overlay>

            <ErrorMessage :value="error" :dismissible="false" />

            <b-table-simple class="mb-0">
                <b-thead>
                    <b-tr>
                        <b-th class="border-top-0 width-500">{{ $t('yourPage') }}</b-th>
                        <b-th class="border-top-0 width-600">{{ $t('webhookUrl') }}</b-th>
                        <b-th class="border-top-0" />
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="item in tipboxes" :key="getItemId(item)">
                        <b-td>{{ item.space.name }}</b-td>
                        <b-td>
                            <FormValidator :attribute="$t('webhookUrl')" :validator="$v.form.webhookUrl[getItemId(item)]" v-slot="slotProps">
                                <div class="d-flex gap-3">
                                    <b-form-input
                                        v-model="form.webhookUrl[getItemId(item)]"
                                        :state="slotProps.state"
                                        placeholder="https://"
                                        class=""
                                        :disabled="requestTipbox.getLoading(getItemId(item))"
                                    />
                                </div>
                            </FormValidator>
                        </b-td>
                        <b-td>
                            <ButtonIcon :loading="requestTipbox.getLoading(getItemId(item))" hide-label-while-loading @click="saveWebhookUrl(item)">
                                {{ $t('save') }}
                            </ButtonIcon>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

        </Card>

    </div>
</template>



<script>
    import { url } from 'vuelidate/lib/validators';
    import FormValidator from '@/components/common/FormValidator.vue';

    export default {
        name: 'WebhooksTipbox',
        components: {
            FormValidator,
        },
        data() {
            return {
                requestTipboxes: this.$req('tipbox/tipboxes'),
                requestTipbox: this.$req('tipbox/tipbox'),
                form: {
                    webhookUrl: {},
                },
            };
        },
        validations() {
            return {
                form: {
                    webhookUrl: this.tipboxes.reduce(
                        (acc, item) => ({
                            ...acc,
                            ...{
                                [this.getItemId(item)]: {
                                    url: () => (this.form.webhookUrl[this.getItemId(item)] ? url(this.form.webhookUrl[this.getItemId(item)]) : true),
                                },
                            },
                        }),
                        {}
                    ),
                },
            };
        },
        computed: {
            tipboxes() {
                return this.requestTipboxes.getData()?.items || [];
            },
            error() {
                return this.requestTipboxes.getError();
            },
            loading() {
                return this.requestTipboxes.getLoading();
            },
        },
        watch: {
            tipboxes() {
                this.form.webhookUrl = this.tipboxes.reduce(
                    (acc, item) => ({
                        ...acc,
                        [this.getItemId(item)]: item.tipbox?.webhook || '',
                    }),
                    {}
                );
            },
        },
        methods: {
            fetchTipboxes() {
                const userId = this.$store.getters['auth/getUser'].id;
                this.requestTipboxes.get(userId).catch(() => {});
            },
            saveWebhookUrl(item) {
                const itemId = this.getItemId(item);
                const space = item.space;
                const webhookUrl = this.form.webhookUrl[itemId] || '';
                this.$v.form.webhookUrl[itemId].$touch();
                if (!this.$v.form.webhookUrl[itemId].$invalid) {
                    this.requestTipbox
                        .id(itemId)
                        .patch({ urlParams: { spaceId: space.id }, requestParams: { webhook: webhookUrl } })
                        .then(() => this.$toastr.success(this.$t('dataSavedSuccessfully')))
                        .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
                }
            },
            getItemId(item) {
                return `${item.space.id}-${item.tipbox?.id || 0}`;
            },
        },
        created() {
            this.fetchTipboxes();
        },
    };
</script>
